<!--
  ~ Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<br/>
@if (permission()) {
  <div class="icd-reporting-header">
    <h1 class="page-header">ICD Search</h1>
    <app-active-search-criteria [filters]="activeFilters()" (remove)="removeSearchTerm($event)"
                                (removeAll)="removeAllSearchTerms()"></app-active-search-criteria>
  </div>
  <ag-grid-angular [gridOptions]="gridOptions" class="ag-theme-balham icd-reporting-grid"
                   [enableCellTextSelection]="true" [columnDefs]="cols" [rowData]="rowDataSignal()"
                   [defaultColDef]="defaultColDef" [autoSizeStrategy]="autoSizeStrategy" [pagination]="false"
                   [suppressMultiSort]="true"
                   (gridReady)="onGridReady($event)" (filterChanged)="onFilterChanged()"
                   (sortChanged)="onSortChanged()" (rowDataUpdated)="onRowDataUpdated()"></ag-grid-angular>
  <app-server-paging-panel [paging]="paging"></app-server-paging-panel>
}
